// Combos de servicio ("Detailing T2"): helpers compartidos entre Remitos y
// Presupuestos. El item del documento lleva comboItems = [{label, incluido}]
// con las inclusiones del combo; se destilda lo que no se hizo en esa visita.

export interface ComboItem {
  label: string;
  incluido: boolean;
}

// Al elegir un producto combo en el buscador de items, sus componentes
// (products.bundleItems) se copian al item del documento, todos tildados.
export function comboDesdeProducto(product: any): ComboItem[] | undefined {
  if (!product?.isBundle) return undefined;
  let arr: any[] = [];
  try {
    arr = Array.isArray(product.bundleItems) ? product.bundleItems : JSON.parse(product.bundleItems || '[]');
  } catch {
    arr = [];
  }
  const combo = arr
    .filter((b) => b && b.name)
    .map((b) => ({ label: Number(b.qty) > 1 ? `${b.name} ×${b.qty}` : String(b.name), incluido: true }));
  return combo.length ? combo : undefined;
}

export function toggleComboItem(combo: ComboItem[], index: number): ComboItem[] {
  return combo.map((c, i) => (i === index ? { ...c, incluido: !c.incluido } : c));
}
